// enums
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { A4_MM_DIMENSION } from "../enums";
// components
import Header from "../components/Header";
import Footer from "../components/Footer";
export default function Page(_param) {
    var { children, id = "page", number = 0, metadata = {}, header = true, footer = true, showDisclaimer = false } = _param, props = _object_without_properties(_param, [
        "children",
        "id",
        "number",
        "metadata",
        "header",
        "footer",
        "showDisclaimer"
    ]);
    const padding = A4_MM_DIMENSION.PADDING;
    const height = A4_MM_DIMENSION.HEIGHT * 1.35; // TODO: Not sure why 1.35 works
    const width = (A4_MM_DIMENSION.WIDTH - 2 * padding) * 1.5;
    const pageStyle = _object_spread({
        width: `${width}mm`,
        minHeight: `${height}mm`,
        maxHeight: `${height}mm`,
        height: `${height}mm`,
        padding: `0px ${padding}mm`
    }, styles.page);
    const config = _object_spread_props(_object_spread({}, metadata), {
        pageNumber: number
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "page",
        children: /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
            id: id,
            className: "page-border",
            style: pageStyle
        }, props), {
            children: [
                /*#__PURE__*/ _jsx(Header, {
                    config: config,
                    visible: header
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: styles.pageContent,
                    children: children
                }),
                /*#__PURE__*/ _jsx(Footer, {
                    config: config,
                    visible: footer,
                    showDisclaimer: showDisclaimer
                })
            ]
        }))
    });
}
const styles = {
    page: {
        height: "100%",
        overflow: "hidden",
        // grid styles -->
        display: "grid",
        gridTemplateRows: "auto 1fr auto",
        gridTemplateColumns: "100%",
        // secondary styles -->
        backgroundColor: "white",
        border: "solid 1px #cececeff",
        boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)"
    },
    pageContent: {
        height: "100%",
        alignSelf: "start",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        gap: "20px"
    }
};
